"use client";

import React from "react";
import { StyledSection } from "./finalCtaBanner.styles";
import { trackEvent } from '@/lib/track';

interface IFinalCtaBannerProps {
  eyebrow?: string;
  headline: string;
  subheadline?: string;
  buttonText: string;
  href: string;
  microcopy?: string;
  eventName?: string;
}

export const FinalCtaBanner = ({
  eyebrow,
  headline,
  subheadline,
  buttonText,
  href,
  microcopy,
  eventName,
}: IFinalCtaBannerProps) => {
  const handleClick = () => {
    if (eventName) trackEvent(eventName);
  };

  return (
    <StyledSection>
      <div className="inner">
        {eyebrow && <span className="eyebrow">{eyebrow}</span>}
        <h2>{headline}</h2>
        {subheadline && <p className="subheadline">{subheadline}</p>}
        <a className="cta" href={href} onClick={handleClick}>
          {buttonText}
          <span aria-hidden="true">→</span>
        </a>
        {microcopy && <p className="microcopy">{microcopy}</p>}
      </div>
    </StyledSection>
  );
};
